const _excluded = ["mediaType", "thumbnailAlt", "thumbnailUrl", "hasLightbox"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { lazy, Suspense } from 'react';
import { SkeletonLoader } from '../SkeletonLoader.js';
import '../Div/index.js';
import '../Image/index.js';
import '../Svg/index.js';
import FallbackImage from '../../../assets/imageFallback-6ecc21de.svg';
import { jsx } from 'react/jsx-runtime';
import { Image } from '../Image/Image.js';
import { Svg } from '../Svg/Svg.js';
import { Div } from '../Div/Div.js';

// eslint-disable-next-line no-restricted-imports -- TODO Fix this
const LazyVideoPlayer = /*#__PURE__*/lazy(async () => ({
  default: (await import('../VideoPlayer/index.js')).VideoPlayer
}));
const LazyLottiePlayer = /*#__PURE__*/lazy(async () => ({
  default: (await import('../Lottie/DynamicLottie.js')).DynamicLottie
}));
function Media(props) {
  return props.mediaType === 'image' ? /*#__PURE__*/jsx(MediaComponent, _objectSpread({}, props)) : /*#__PURE__*/jsx(Suspense, {
    fallback: /*#__PURE__*/jsx(SkeletonLoader, {}),
    children: /*#__PURE__*/jsx(MediaComponent, _objectSpread({}, props))
  });
}
function MediaComponent(_ref) {
  let mediaType = _ref.mediaType,
    thumbnailAlt = _ref.thumbnailAlt,
    thumbnailUrl = _ref.thumbnailUrl,
    hasLightbox = _ref.hasLightbox,
    mediaProps = _objectWithoutProperties(_ref, _excluded);
  if (mediaType === 'image') {
    return /*#__PURE__*/jsx(Image, _objectSpread(_objectSpread({
      alt: "default alt"
    }, mediaProps), {}, {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO Fix this
      src: mediaProps.src || FallbackImage
    }));
  }
  if (mediaType === 'svg') {
    return /*#__PURE__*/jsx(Svg, _objectSpread({}, mediaProps));
  }
  if (mediaType === 'video') {
    return /*#__PURE__*/jsx(Div, {
      flexDirection: "column",
      width: "100%",
      justifyContent: "center",
      flex: 1,
      children: /*#__PURE__*/jsx(LazyVideoPlayer, _objectSpread(_objectSpread({}, mediaProps), {}, {
        thumbnailAlt: thumbnailAlt,
        thumbnailUrl: thumbnailUrl,
        hasLightbox: hasLightbox
      }))
    });
  }
  if (mediaType === 'lotti') {
    return /*#__PURE__*/jsx(Div, {
      flexDirection: "column",
      width: "100%",
      justifyContent: "center",
      children: /*#__PURE__*/jsx(LazyLottiePlayer, _objectSpread({}, mediaProps))
    });
  }
  return null;
}
export { Media, MediaComponent };
//# sourceMappingURL=Lazymedia.js.map
